export const qrMismatchLabels = Object.freeze({
  amount: 'Monto',
  receipt_number: 'Número de transacción',
  date: 'Fecha de depósito',
  qr_unreadable: 'QR ilegible',
});

export const qrStatusLabels = Object.freeze({
  legacy: 'Comprobante anterior a la validación QR',
  manual_review_required: 'Revisión manual con alerta',
  qr_fields_matched: 'Datos QR coincidentes',
  pending: 'Verificación QR pendiente',
});

export const qrMatchedNotice = 'Se compararon los datos locales del QR; esto no certifica autenticidad ni aprobación bancaria.';
